//#region IMPORTS
import { InstoreOrderLineTableRow } from "../../models/instoreOrder";
import { VirtualItem, Virtualizer } from "@tanstack/react-virtual";
import { flexRender, Row } from "@tanstack/react-table";
import classNames from "../../helpers/classNames";
//#endregion

interface Props {
  row: Row<InstoreOrderLineTableRow>;
  virtualRow: VirtualItem;
  rowVirtualizer: Virtualizer<HTMLDivElement, HTMLTableRowElement>;
}

export default function InstoreOrderDetailTableBodyRow({
  row,
  virtualRow,
  rowVirtualizer,
}: Props) {
  return (
    <tr
      data-index={virtualRow.index} //needed for dynamic row height measurement
      ref={(node) => rowVirtualizer.measureElement(node)} //measure dynamic row height
      key={row.id}
      className={classNames(
        row.original.parent ? "bg-gray-100" : "",
        row.original.placeholder ? "border-amber-600" : "border-slate-300",
        "border-t h-12 w-full flex items-center absolute"
      )}
      style={{
        transform: `translateY(${virtualRow.start}px)`, //this should always be a `style` as it changes on scroll
      }}
    >
      {row.getVisibleCells().map((cell, i) => {
        const isParent = row.original.parent;
        const colSpan = isParent && i === 1 ? 2 : 1; // first column spans 2

        return (
          <td
            key={cell.id}
            colSpan={colSpan}
            className={classNames(
              row.original.parent
                ? "font-bold text-gray-800 text-sm"
                : row.original.placeholder
                ? "text-xs text-amber-800 animate-pule"
                : "text-xs text-gray-600",
              "whitespace-nowrap px-2 text-left sm:pl-0"
            )}
            style={{
              width: cell.column.getSize(),
            }}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </td>
        );
      })}
    </tr>
  );
}
